import React, { useState, useEffect, useContext } from "react"; 
import API from "../api/api";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

export default function Register() {
  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const [clubs, setClubs] = useState([]);
  const [image, setImage] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    name: "",
    surname: "",
    dob: "",
    gender: "",
    club_id: "",
    phone_number: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

const imageRef = useRef(null);

  const [errors, setErrors] = useState({
  name: false,
  surname: false,
  dob: false,
  gender: false,
  club_id: false,
  phone_number: false,
  email: false,
  password: "",
  confirmPassword: "", // add this
  image: "",
  submit: "",
});

  // Load clubs
  useEffect(() => {
    const loadClubs = async () => {
      try {
        const res = await API.get("/clubs");
        setClubs(Array.isArray(res) ? res : []);
      } catch (err) {
        console.error("Клубыг ачааллахад алдаа гарлаа:", err);
      }
    };
    loadClubs();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    // Clear errors as user types
    if (["password", "confirmPassword"].includes(e.target.name)) {
      setErrors({ ...errors, password: "" });
    } else if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: false });
    }
  };

  const handleImage = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
  if (!allowedTypes.includes(file.type)) {
    setErrors({
      ...errors,
      image: "Зураг JPG, PNG, WEBP байх ёстой",
    });
    imageRef.current = null;
    setImage(null);
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    setErrors({
      ...errors,
      image: "Файлын хэмжээ 5MB-с их байна",
    });
    imageRef.current = null;
    setImage(null);
    return;
  }

  imageRef.current = file;   // ✅ SAFARI SAFE
  setImage(file);            // UI state
  setErrors({ ...errors, image: "" });
};

  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors, submit: "" };

    // Required fields
    ["name", "surname", "dob", "gender", "club_id", "phone_number", "email", "password", "confirmPassword"].forEach((field) => {
      if (!form[field]) {
        newErrors[field] = true;
        valid = false;
      }
    });

    // Password match
    if (form.password !== form.confirmPassword) {
  newErrors.confirmPassword = "Нууц үг таарахгүй байна!";
  valid = false;
}

    // Image required
    if (!imageRef.current) {
  newErrors.image = "Профайл зураг шаардлагатай";
  valid = false;
}

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (submitting) return;

  if (!validateForm()) return;

  setSubmitting(true);

  try {
    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (key !== "confirmPassword" && value !== undefined) {
        data.append(key, value);
      }
    });

    if (imageRef.current) {
      data.append("image", imageRef.current); // backend expects req.file as "image"
    }

    const res = await API.postForm("/fighters/register", data);

    const { fighter, token } = res;
    if (!fighter || !token) throw new Error("Серверээс буруу хариу ирлээ");

    setAuth(token, {
      id: fighter.fighter_id,
      fighter_id: fighter.fighter_id,
      name: fighter.name,
      surname: fighter.surname,
      email: fighter.email,
      phone_number: fighter.phone_number,
      dob: fighter.dob,
      gender: fighter.gender,
      club_id: fighter.club_id,
      club_name: fighter.club_name || null,
      height: fighter.height,
      actual_weight: fighter.actual_weight,
      wins: fighter.wins,
      losses: fighter.losses,
      coach_name: fighter.coach_name,
      fighting_style: fighter.fighting_style,
      nickname: fighter.nickname,
      nationality: fighter.nationality || "Mongolia",
      bio: fighter.bio,
      // NEW optimized images
      image_small: fighter.image_small || fighter.image_url,
      image_large: fighter.image_large || fighter.image_url,
      image_url: fighter.image_url, // legacy fallback
      role: "fighter",
    });

    navigate("/profile");
  } catch (err) {
    console.error("Бүртгэлийн алдаа:", err);
    setErrors({
      ...errors,
      submit:
        err.response?.data?.error ||
        err.message ||
        "Бүртгэл амжилтгүй боллоо. Дахин оролдоно уу.",
    });
  } finally {
    setSubmitting(false);
  }
};

  const inputClass = (error) =>
    `w-full p-3 rounded-lg bg-zinc-800 border ${error ? "border-red-500" : "border-zinc-700"} focus:ring-2 focus:ring-yellow-500`;

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-3xl bg-zinc-900/60 backdrop-blur-xl p-10 rounded-2xl shadow-2xl border border-zinc-800">
        <h1 className="text-4xl font-extrabold text-yellow-400 text-center mb-10 drop-shadow-lg tracking-wider uppercase">
          Тамирчны бүртгэл
        </h1>

        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-6 text-white">
          {/* Surname + Name */}
          <div className="col-span-1">
            <label className="block mb-1 text-sm font-semibold">Овог *</label>
            <input name="surname" className={inputClass(errors.surname)} onChange={handleChange} />
          </div>
          <div className="col-span-1">
            <label className="block mb-1 text-sm font-semibold">Нэр *</label>
            <input name="name" className={inputClass(errors.name)} onChange={handleChange} />
          </div>

          {/* DOB */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">Төрсөн өдөр *</label>
            <input name="dob" type="date" className={inputClass(errors.dob)} onChange={handleChange} />
          </div>

          {/* Gender */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">Хүйс *</label>
            <select name="gender" className={inputClass(errors.gender)} onChange={handleChange}>
              <option value="">Хүйсээ сонгоно уу</option>
              <option value="Male">Эрэгтэй</option>
              <option value="Female">Эмэгтэй</option>
            </select>
          </div>

          {/* Club */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">Клуб *</label>
            <select name="club_id" className={inputClass(errors.club_id)} onChange={handleChange}>
              <option value="">Клубээ сонгоно уу</option>
              {clubs.map((c) => <option key={c.club_id} value={c.club_id}>{c.club_name}</option>)}
            </select>
          </div>

          {/* Phone */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">Утасны дугаар *</label>
            <input name="phone_number" className={inputClass(errors.phone_number)} onChange={handleChange} />
          </div>

          {/* Email */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">И-мэйл *</label>
            <input type="email" name="email" className={inputClass(errors.email)} onChange={handleChange} />
          </div>

          {/* Password */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">Нууц үг *</label>
            <input type="password" name="password" className={inputClass(errors.password)} onChange={handleChange} />
          </div>

          {/* Confirm Password */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">Нууц үг давтах *</label>
            <input type="password" name="confirmPassword" className={inputClass(errors.confirmPassword)} onChange={handleChange} />
            {errors.confirmPassword && <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>}
          </div>

          {/* Image */}
          <div className="col-span-2">
            <label className="block mb-1 text-sm font-semibold">Профайл зураг *</label>
            <input
  type="file"
  accept="image/jpeg,image/png,image/webp"
  className={inputClass(errors.image)}
  onChange={handleImage}
/>
{image && imageRef.current && (
  <img
    src={URL.createObjectURL(image)}
    alt="preview"
    className="mt-2 w-32 h-32 object-cover rounded-full border-2 border-yellow-500"
  />
)}

            {errors.image && <p className="text-red-500 text-sm mt-1">{errors.image}</p>}
          </div>

          {errors.submit && <p className="col-span-2 text-red-500 text-sm mt-1">{errors.submit}</p>}

          <button type="submit" disabled={submitting} className={`col-span-2 bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-xl mt-4 font-bold text-lg transition-all duration-200 ${submitting ? "opacity-50 cursor-not-allowed" : ""}`}>
            {submitting ? "Бүртгэж байна..." : "Бүртгүүлэх"}
          </button>
        </form>
      </div>
    </div>
  );
}
